module.exports = __webpack_public_path__ + "assets/img/chronicleImg-80580bd7.png";